import { useEffect } from 'react';

function useOnUnmount(fn) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fn, []);
}

export default useOnUnmount;
